import React from 'react'
import IconButton from '@material-ui/core/IconButton'
import { AccessTime, Sync, DeleteForeverOutlined, EditOutlined } from '@material-ui/icons'
import { IScheduleRecord } from '../../types/publishSchedule'
import { scheduleModalOpen, deleteScheduleModalOpen } from '../../actions/publishSchedule'
import { scheduleDataToFormState, renderScheduleDateTime } from '../../services/publishSchedule'
import { usePublishScheduleDispatch } from './hooks'
import { P } from '../StyledText'

export interface IScheduleListItem {
  schedule: IScheduleRecord
}

export const ScheduleListItem = ({ schedule }: IScheduleListItem) => {
  const dispatch = usePublishScheduleDispatch()
  return (
    <li className="auto-schedule-list-item">
      {schedule.recurring
        ? <Sync className="icon left-list-item-area" />
        : <AccessTime className="icon left-list-item-area" />}
      <P className="text-list-item-area">{renderScheduleDateTime(schedule)}</P>
      <div className="right-list-item-area">
        <IconButton
          className="auto-delete-schedule-icon"
          onClick={() => dispatch(deleteScheduleModalOpen(schedule.scheduleId))}
          aria-label="delete">
          <DeleteForeverOutlined className="icon" />
        </IconButton>
        <IconButton
          className="auto-edit-schedule-icon"
          onClick={() => dispatch(scheduleModalOpen(scheduleDataToFormState(schedule), schedule.scheduleId))}
          aria-label="edit"
        >
          <EditOutlined className="icon" />
        </IconButton>
      </div>
    </li>
  )
}
